import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../components/Hooks/useWidth';
import { getModalFooterSize } from './utils';

type UseStylesProps = {
  footerHeight: number;
};

const useStyles = makeStyles<UseStylesProps>()((theme, { footerHeight }) => ({
  rootWithoutCreateSignImage: {
    [theme.breakpoints.only('sm')]: {
      height: `calc(100% - ${footerHeight + 42}px)`,
    },
    [theme.breakpoints.only('xs')]: {
      height: `calc(100% - ${footerHeight + 5}px)`,
    },
    width: '100%',
    overflowX: 'hidden',
    height: `calc(100% - ${footerHeight - 12}px)`,
  },
  rootCreateSignImage: {
    [theme.breakpoints.only('sm')]: {
      height: `calc(100% - ${footerHeight}px)`,
    },
    [theme.breakpoints.only('xs')]: {
      height: `calc(100% - ${footerHeight - 30}px)`,
    },
    width: '100%',
    overflowX: 'hidden',
    height: `calc(100% - ${footerHeight - 12}px)`,
  },
}));

type FullWidthBoxWrapperProps = {
  children: React.ReactNode;
  isCreateSignImage?: boolean;
};

const FullWidthBoxWrapper = ({ children, isCreateSignImage }: FullWidthBoxWrapperProps) => {
  const { mobileWidth } = useWidth();
  const footerHeight = getModalFooterSize(mobileWidth);
  const { classes } = useStyles({ footerHeight });

  return (
    <Box
      className={
        isCreateSignImage ? classes.rootCreateSignImage : classes.rootWithoutCreateSignImage
      }
      sx={{
        display: 'flex',
      }}
    >
      {children}
    </Box>
  );
};

export default FullWidthBoxWrapper;
